export default __webpack_public_path__ + "static/media/wi_13n_snow.faa2a958.svg";